export type MaterialId = 'recyclage' | 'ordures' | 'organiques' | 'verts'

export interface Material {
  id: MaterialId
  label: string
  hint: string
}

export interface Collection {
  id: string
  weekday: string
  date: string
  materials: MaterialId[]
}

/**
 * Les bacs et les jours viennent du vrai calendrier de Beaconsfield : ordures et
 * recyclage le jeudi pour toute la ville, matières organiques le mardi au sud de
 * l'autoroute 20 et le lundi au nord. Les sacs de plastique sont refusés pour les
 * organiques, même biodégradables.
 */
export const materials: Record<MaterialId, Material> = {
  recyclage: { id: 'recyclage', label: 'Recyclage', hint: 'Bac bleu' },
  ordures: { id: 'ordures', label: 'Ordures', hint: 'Bac gris' },
  organiques: { id: 'organiques', label: 'Matières organiques', hint: 'Sacs de papier ou bac' },
  verts: { id: 'verts', label: 'Branches et résidus verts', hint: 'En bordure de rue' },
}

export const citizenAddress = '366, chemin Lakeshore, Beaconsfield · Sud de l’autoroute 20'

export const quickPrompts = ['Bac non ramassé', 'Prochaine collecte', 'Quel bac sortir ?', 'Autre problème']

export const collections: Collection[] = [
  {
    id: 'oct-06',
    weekday: 'Aujourd’hui',
    date: 'mardi 6 octobre',
    materials: ['organiques'],
  },
  {
    id: 'oct-08',
    weekday: 'Jeudi',
    date: '8 octobre',
    materials: ['ordures', 'recyclage'],
  },
  {
    id: 'oct-13',
    weekday: 'Mardi',
    date: '13 octobre',
    materials: ['organiques', 'verts'],
  },
]

/** Suivi en direct du camion pour la collecte du jour. */
export const liveCollection = {
  material: 'organiques' as MaterialId,
  sector: 'Sud de l’autoroute 20',
  truck: 'Camion 12',
  startedAt: 'Départ du garage à 7 h',
  home: [45.4252, -73.8672] as [number, number],
  /** Trajet du camion, du premier point (déjà parcouru) jusqu’à votre adresse. */
  route: [
    [45.4268, -73.8585],
    [45.4264, -73.8601],
    [45.4261, -73.8616],
    [45.4258, -73.863],
    [45.4256, -73.8643],
    [45.4254, -73.8653],
    [45.4253, -73.8661],
    [45.4252, -73.8666],
    [45.4252, -73.867],
    [45.4252, -73.8672],
  ] as [number, number][],
  /** Avancement initial du camion sur le trajet (0 → 1). */
  startProgress: 0.42,
}
